import classes from "./ButtonsGroup.module.css";
import {
  KeyboardBackspace,
  Send,
} from "@material-ui/icons";

export default function ButtonsGroup({
  onPrev,
  onNext,
  onlyPrev,
  onlyNext,
  prevDisabled,
  nextDisabled,
  submitButton,
  submitDisabled,
  onSubmit,
  submitText
}) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        alignItems: "center",
        marginTop: "3rem",
      }}
    >
      {!onlyNext && (
        <button
          className={classes.previousButton}
          variant="contained"
          onClick={onPrev}
          disabled={prevDisabled}
        >
          <KeyboardBackspace />
          Previous
        </button>
      )}

      {!onlyPrev && (
        <button
          className={classes.nextButton}
          variant="contained"
          onClick={onNext}
          disabled={nextDisabled}
        >
          Next
          <KeyboardBackspace style={{ transform: "rotate(180deg)" }} />
        </button>
      )}

      {
        submitButton && (
        <button
        className={classes.nextButton}
        variant="contained"
        onClick={onSubmit}
        disabled={submitDisabled}
      >
        {submitText}{" "}
        <Send />
      </button>
        )
      }
    </div>
  );
}
